import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Setting} from "./setting";
import {
    addComponentAsset,
    addComponentReference, addComponentTag,
    deleteComponent, removeComponentTag,
    saveSettingComponent
} from "./componentsSlice";

export interface SettingState {
    projectSetting?: Setting,
    storySetting?: Setting,
    status: Status,
    error: string | null | undefined
}

const initialState: SettingState = {
    projectSetting: undefined,
    storySetting: undefined,
    status: Status.Idle,
    error: null,
}

export const fetchGlobalSetting = createAsyncThunk('projectSetting', async (params: { settingId: number, projectId: number }) => {
    const response = await axios.get(`${process.env.REACT_APP_API}/settings/${params.settingId}`, {
        headers: headers(params.projectId.toString())
    })
    return response.data
})

export const fetchStorySetting = createAsyncThunk('storySetting', async (params: { settingId: number, projectId: number }) => {
    const response = await axios.get(`${process.env.REACT_APP_API}/settings/${params.settingId}`, {
        headers: headers(params.projectId.toString())
    })
    return response.data
})

export const settingSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGlobalSetting.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchGlobalSetting.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.projectSetting = action.payload
            })
            .addCase(fetchGlobalSetting.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(fetchStorySetting.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchStorySetting.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.storySetting = action.payload
            })
            .addCase(fetchStorySetting.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(saveSettingComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveSettingComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentAsset.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentAsset.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentReference.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentReference.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(removeComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})

export default settingSlice.reducer;